// Entry point of the HORIZON advisor SPA.
// Token stylesheet first, application styles second: every application rule is
// allowed to reference --hz-* variables but never to redefine a raw colour.
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '@horizon/ui/src/styles/tokens.css';
import './styles/base.css';
import App from './App.vue';
import router from './router';

/**
 * Copy the navy token into the theme-color meta tag so the mobile browser chrome
 * matches the design system without duplicating the colour value in the markup.
 */
function synchroniserCouleurTheme(): void {
  const balise = document.getElementById('hz-theme-color');
  if (!(balise instanceof HTMLMetaElement)) {
    return;
  }
  const navy = getComputedStyle(document.documentElement)
    .getPropertyValue('--hz-primary-900')
    .trim();
  if (navy.length > 0) {
    balise.content = navy;
  }
}

const application = createApp(App);
application.use(createPinia());
application.use(router);

router
  .isReady()
  .then(synchroniserCouleurTheme)
  .catch(() => {
    // A failed initial resolution is already surfaced by the router error handler;
    // the theme colour is cosmetic and must not block the mount.
  });

application.mount('#app');
